import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LandingHeader from '../Shared/LandingHeader';
import LandingFooter from '../Shared/LandingFooter';
import './TermsOfService.css';

const TermsOfService = () => {
    const { t } = useTranslation(['terms', 'common']);
    const sections = t('terms:sections', { returnObjects: true }) || [];

    return (
        <div className="tos-page">
            <LandingHeader activePage="terms" />

            <main style={{ paddingTop: '80px' }}>
                {/* Hero */}
                <section className="tos-hero">
                    <div className="tos-container">
                        <div className="tos-hero-badge">{t('terms:hero.badge')}</div>
                        <h1>{t('terms:hero.title')} <span className="tos-gradient">{t('terms:hero.titleHighlight')}</span></h1>
                        <p className="tos-hero-sub">{t('terms:hero.subtext')}</p>
                        <div className="tos-meta">
                            <span>📅 {t('terms:hero.lastUpdatedLabel', 'Last Updated')}: {t('terms:hero.lastUpdated')}</span>
                            <span>⏱ {t('terms:hero.readTime')}</span>
                        </div>
                    </div>
                    <div className="tos-hero-glow" />
                </section>

                {/* Table of Contents */}
                <section className="tos-toc-section">
                    <div className="tos-container">
                        <div className="tos-toc">
                            <h3>{t('terms:tocTitle')}</h3>
                            <ul>
                                {sections.map((s) => (
                                    <li key={s.id}>
                                        <a href={`#section-${s.id}`}>
                                            <span className="tos-toc-num">{s.id}</span>
                                            {s.title}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </section>

                {/* Content */}
                <section className="tos-content-section">
                    <div className="tos-container tos-layout">
                        <div className="tos-sections">
                            {sections.map((sec) => (
                                <div className="tos-section" id={`section-${sec.id}`} key={sec.id}>
                                    <div className="tos-section-header">
                                        <span className="tos-section-num">{sec.id}</span>
                                        <h2>{sec.title}</h2>
                                    </div>
                                    <div className="tos-sub-items">
                                        {sec.content.map((item, i) => (
                                            <div className="tos-sub-item" key={i}>
                                                <h4>{item.subtitle}</h4>
                                                <p>{item.text}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Sticky sidebar */}
                        <aside className="tos-sidebar">
                            <div className="tos-sidebar-card">
                                <div className="tos-sidebar-icon">⚖️</div>
                                <h3>{t('terms:sidebar.fairTitle')}</h3>
                                <p>{t('terms:sidebar.fairText')}</p>
                            </div>
                            <div className="tos-sidebar-card">
                                <div className="tos-sidebar-icon">📬</div>
                                <h3>{t('terms:sidebar.contactTitle')}</h3>
                                <p>{t('terms:sidebar.contactText')}</p>
                                <a href="mailto:support@skilltherapyai.com" className="tos-contact-link">
                                    support@skilltherapyai.com
                                </a>
                            </div>
                            <div className="tos-sidebar-card tos-sidebar-card--highlight">
                                <h3>{t('terms:sidebar.relatedTitle')}</h3>
                                <ul className="tos-related-links">
                                    <li><Link to="/privacy">{t('common:privacy', 'Privacy Policy')}</Link></li>
                                    <li><Link to="/about">{t('common:about', 'About Us')}</Link></li>
                                </ul>
                            </div>
                        </aside>
                    </div>
                </section>

                {/* CTA */}
                <section className="tos-cta-section">
                    <div className="tos-container">
                        <h2>{t('terms:cta.title')}</h2>
                        <p>{t('terms:cta.text')}</p>
                        <a href="mailto:support@skilltherapyai.com" className="tos-btn-primary">
                            {t('terms:cta.button')}
                        </a>
                    </div>
                </section>
            </main>

            <LandingFooter />
        </div>
    );
};

export default TermsOfService;
